
/**
 * @description 格式化时间戳
 * @param  timestamp 需要格式化的时间戳
 */
export const formatTime = timestamp => {
  // 创建一个 Date 对象
  const date = new Date(timestamp)
  // 获取年份
  const year = date.getFullYear()
  // 获取月份，注意 getMonth() 返回值是 0 - 11，所以要加 1
  const month = String(date.getMonth() + 1).padStart(2, '0')
  // 获取日期
  const day = String(date.getDate()).padStart(2, '0')
  // 获取小时
  const hours = String(date.getHours()).padStart(2, '0')
  // 获取分钟
  const minutes = String(date.getMinutes()).padStart(2, '0')
  // 获取秒数
  const seconds = String(date.getSeconds()).padStart(2, '0')
  // 拼接成所需格式
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}



/**
 * @description 防抖函数 事件触发过于频繁 只执行一次
 * @param  fn 需要绑定的执行函数
 * @param  wait 等待时间
 */
export const debouncefun = function (fn, wait) {
  // 声明变量用于接收定时器id
  let timerId
  return function (...args) {
    // 调用时清除之前的定时器，继续等待
    clearTimeout(timerId)
    // 开启新的定时器，没有继续操作时，执行最后一次操作
    timerId = setTimeout(() => {
      // 函数使用apply方法 指定上下文操作对象this，参数二是数组参数的传递
      fn.apply(this, args)
    }, wait)
  }
}

/**
 * @description 节流函数 事件触发过于频繁 控制单位时间的执行次数
 * @param  fn 需要绑定的执行函数
 * @param  wait 等待时间
 */
export const throttlefun = function (fn, wait) {
  // 声明一个开关
  let flag = true
  return function (...args) {
    // 执行一次函数
    if (flag) {
      // 执行时就关掉开关
      flag = false
      setTimeout(() => {
        // 函数使用apply方法 指定上下文操作对象this，参数二是数组参数的传递
        fn.apply(this, args)
        // 开启定时器的时候打开开关
        flag = true
      }, wait)
    }
  }
}

// 实体html解密函数
export const strHtml = function (htmlString) {
  const parser = new DOMParser();
  const doc = parser.parseFromString('<!DOCTYPE html><body>' + htmlString + '</body>', 'text/html');
  return doc.body.textContent;
}

// 过滤数字日期
export const formatTimes = function (strDate) {
  var dateStr = strDate
  var year = dateStr.slice(0, 4)
  var month = dateStr.slice(4, 6)
  var day = dateStr.slice(6)
  var formatted = year + "-" + month + "-" + day
  return formatted
}

// 去除CN
export const substr = function (str) {
  return str.slice(2)
}

// 获取年月日
export const getDate = function (format = 'YYYY-MM-DD') {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  if (format === 'YYYY-MM-DD') {
    return `${year}-${month}-${day}`;
  } else if (format === 'YYYY/MM/DD') {
    return `${year}/${month}/${day}`;
  } else if (format === 'YYYY年MM月DD日') {
    return `${year}年${month}月${day}日`;
  } else if (format === 'YYYYMMDD') {
    return `${year}${month}${day}`;
  }
  return `${year}-${month}-${day}`;
}

// 获取随机数
export const getRand = function () {
  return Math.floor(Math.random() * 9000) + 1000;
}


